var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16014 12.3394C5.95941 13.1387 5.95941 14.4346 5.16014 15.2338C4.36087 16.0331 3.06499 16.0331 2.26571 15.2338C1.46644 14.4346 1.46644 13.1387 2.26571 12.3394C3.06499 11.5401 4.36086 11.5401 5.16014 12.3394",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.28342L2.69165 12.0168",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16014 4.76617C5.95941 5.56545 5.95941 6.86132 5.16014 7.6606C4.36087 8.45987 3.06499 8.45987 2.26571 7.6606C1.46644 6.86132 1.46644 5.56545 2.26571 4.76617C3.06499 3.9669 4.36086 3.9669 5.16014 4.76617",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.7167L2.69165 7.98337",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1942 9.86414C18.1175 9.86414 18.055 9.92664 18.0558 10.0033C18.0558 10.08 18.1183 10.1425 18.195 10.1425C18.2717 10.1425 18.3342 10.08 18.3342 10.0033C18.3342 9.92664 18.2708 9.86414 18.1942 9.86414",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2779 9.86414C15.2012 9.86414 15.1387 9.92664 15.1396 10.0033C15.1396 10.08 15.2021 10.1425 15.2787 10.1425C15.3554 10.1425 15.4179 10.08 15.4179 10.0033C15.4179 9.92664 15.3546 9.86414 15.2779 9.86414",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3604 9.86414C12.2838 9.86414 12.2213 9.92664 12.2221 10.0033C12.2221 10.08 12.2846 10.1425 12.3613 10.1425C12.4379 10.1425 12.5004 10.08 12.5004 10.0033C12.5004 9.92664 12.4371 9.86414 12.3604 9.86414",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrop);
export default ForwardRef;